import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { StringRequest } from "../../sysadmin/services/StringRequest";

@Injectable()
export class HomeService {
	constructor(private httpclientService: HttpclientService) {}

	SectionGetList(PeriodID, ClassDate) {
		var postResult$ = new Subject();
		var url = "attendance/SectionGetList?PeriodID=" + PeriodID + "&classdate=" + ClassDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PeriodGetList(ClassDate) {
		var postResult$ = new Subject();
		var url = "attendance/PeriodGetList?classDate=" + ClassDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetAttendance(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "attendance/GetAttendance";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InsertInstructorMessage(SectionScheduleDetailID, InsertDate) {
		var postResult$ = new Subject();
		var url = "attendance/InsertInstructorMessage?SectionScheduleDetailID=" + SectionScheduleDetailID + "&InsertDate=" + InsertDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
